import { SubscriptionTier } from '@heidi/schema/ml-scribe';
import { useUserBillingInfo } from './injected-billing';

export function useIsFreeUser() {
  const { data: billingInfo } = useUserBillingInfo();

  return {
    isFreeUser: billingInfo?.third_party_license?.latest_tier
      ? billingInfo?.third_party_license?.latest_tier === SubscriptionTier.FREE
      : billingInfo?.tier === SubscriptionTier.FREE,
  };
}
